import { UseQueryOptions } from 'react-query';
import { Sprint } from 'api/sprint-planning/types';
import { useGetSprintDetailQuery } from 'queries/sprint-planning';
import { useGetSprintId } from './use-get-sprint-id';

export const useSprintDetails = (
  options?: UseQueryOptions<Sprint, unknown, Sprint, [string, number]>,
) => {
  const { sprintId } = useGetSprintId();

  const { data, isLoading, isFetching, refetch } = useGetSprintDetailQuery(
    Number(sprintId),
    options,
  );

  return {
    isLoading,
    isFetching,
    data,
    refetch,
  };
};
